import { OnSchedHelpers } from ".";

export const TriggerAfterTyping = (element, inputId, interval, callback) => {
  OnSchedHelpers.CalendarLoading(element, true)
  //setup before functions
  let typingTimer;                //timer identifier
  let doneTypingInterval = interval;  //time in ms (5 seconds)
  let myInput = document.getElementById(inputId);

  //on keyup, start the countdown
  myInput.addEventListener('keyup', () => {
      clearTimeout(typingTimer);
      if (myInput.value) {
          typingTimer = setTimeout(doneTyping, doneTypingInterval);
      }
  });

  //user is "finished typing," do something
  function doneTyping () {
      //do something
      OnSchedHelpers.CalendarLoading(element, false)
      callback()
  }
}

